import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider, FieldArray } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {  Apitoken, Authtoken } from '../Global';
import $ from "jquery";
const StockFollowUpAdd = () => {
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [statusOptions, setStatusOptions] = useState([]);
  const [permission, setPermission] = useState({});

  const [menu, setMenu] = useState(false);
  // const [currencySymbol, setCurrencySymbol] = useState('dh');
  const [locationLoading, setLocationLoading] = useState([]);
  const [suppliers, setSuppliers] = useState([]);

  const [showTableHeadings, setShowTableHeadings] = useState(false);
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [defaultDate, setDefaultDate] = useState(formatDate(new Date()));
    let season_id = localStorage.getItem("season_id");

  const formik = useFormik({
    initialValues: {
      season_id:season_id,
      consumable_name: "",
      location: "",
      date:defaultDate,
      quantity: "",
      delivery_note_number: "",
      supplier: "",
      currency: "4",
      total_amount: "",
      delivery_note:"",
      operation:"",
      contents:[]

    },

    onSubmit: (values,{ setSubmitting }) => {
      axios
        .post("/stock-follow-ups/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          // actions.setSubmitting(false);
          setSubmitting(false);
          $("#form-submit").text("Add Stock Situation");
          if (response.data.code === 200) {
            //setBackendSuccess(response.data.message);
              toast.success(response.data.message);
            //actions.resetForm();
            setTimeout(() => {
              window.location.href = "/stock-situations";
            }, 1000);
          } 
           else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          // actions.setSubmitting(false);
          toast.error(error);

        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const operationArr = ([
    { value: 'IN', label: "IN" },
    { value: 'OUT', label: "OUT" },
  ]);

   const primaryCurrency =  [
    {
        "label": "EUR",
        "value": 1,
        "symbol": "€",
        "key": "cabrane-0"
    },
    {
        "label": "USD",
        "value": 2,
        "symbol": "$",
        "key": "cabrane-1"
    },
    {
        "label": "GBP",
        "value": 3,
        "symbol": "£",
        "key": "cabrane-2"
    },
    {
        "label": "MAD ",
        "value": 4,
        "symbol": "dh",
        "key": "cabrane-3"
    }
];
  useEffect(() => {
        setPermission(FindModuleById(151)); 
console.log(permission);

        axios.post("/consumables/listing",{}, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if(response.data.code === 200){
            let supplier_types = response.data.data.products;
           // setPackagingTypesLists(materials_payment_status);
            let supplier_typesList = supplier_types.map((ord, index) => ({
              label:  ord.consumable_name ,
              value: ord.id,
              key: `supplier-${index}`,
            }));
            setStatusOptions(supplier_typesList);
        }else{
            console.log("API response is not an array");
          }
                  
        })
        .catch((error) => {
          console.log(error);
        });


        
        axios
        .get(`/helpers/supplier-list-except-transport-farmers-traders`, {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken,
          },
        }).then((response) => {
          if(response.data.code === 200){
            let supplier_types = response.data.data.suppliers;
           // setPackagingTypesLists(materials_payment_status);
            let supplier_typesList = supplier_types.map((ord, index) => ({
              label:  ord.name ,
              value: ord.id,
              key: `supplier-${index}`,
            }));
            setSuppliers(supplier_typesList);
        }else{
            console.log("API response is not an array");
          }
                  
        })
        .catch((error) => {
          console.log(error);
        });


    axios
    .get(`/helpers/loading-locations`, {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken,
      },
    })
    .then((response) => {
      if (response.data.code === 200) {
        let locations = response.data.data.locations;
        let locationslisting = locations.map((ord, index) => ({
          label: ord.title,
          value: ord.id,
          key: `location-${index}`,
        }));
        setLocationLoading(locationslisting);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });
}, []);



const customHandleInput = (event) => {
  const Input_name = event.target.name;
  delete backendErrors[Input_name];
};
    
// const getFileData = async (event) =>{
//   const file_link = event.target.files[0];
//   const fileName = file_link.name;
//   const withoutExtension = fileName.replace(/\.[^.]+$/, '');

//   //var id_value = event.target.id;
//   //const ids = id_value.split("-");
//   //formik.values.files[ids[1]].file_name = withoutExtension;
// }  

const handleSelectChange = (name, selectedOption) => {
  const value = selectedOption ? selectedOption.value : "";
  updateFormikValue(name, value);
  customHandleInput({ target: { name, value } });
};

const updateFormikValue = (name, value) => {
  formik.setFieldValue(name, value);
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Stock Situation </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/stock-situations">Stock Situation</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Stock Situation</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Stock Situation  Information</h4>
                    {permission && permission.add == 1 && (

                          <FormikProvider value={formik}>
                          <form action="#" onSubmit={formik.handleSubmit}>
                          
                          <div className="row">
                            
                          <div className="col-md-4 out-operation all-operation">
                                <div className="form-group status">
                                    <label>Location</label>
                                  
                                      <Select
                                        className="w-100"
                                        value={locationLoading.find(option => option.value == formik.values.location) || null} // Ensure correct format
                                        name="location"
                                        onChange={(selectedOption) => {
                                        handleSelectChange("location", selectedOption);
                                    //   generateLotNumberLocation(selectedOption.value);
                                        }}
                                        onBlur={formik.handleBlur}
                                        options={locationLoading}
                                        placeholder="Select"

                                        // value={formik.values.location}
                                        // name="location"
                                        // data={locationLoading}
                                        // className={
                                        //   backendErrors.location
                                        //     ? "w-100 input-error"
                                        //     : "w-100"
                                        // }
                                        // onChange={(e) => {
                                        //   formik.handleChange(e);
                                        //   customHandleInput(e);
                                        // }}
                                        //  onBlur={formik.handleBlur}
                                        // options={{
                                        //   placeholder: "Select a Location",
                                        // }}
                                      />
                                
                                    <small>
                                      {backendErrors.location && (
                                          <span className="form-error mt-1">
                                            {backendErrors.location}
                                          </span>
                                        )}
                                    </small>
                                  </div>
                            </div>
                            <div className="col-md-4 all-operation">
                              <div className="form-group">
                                <label> Date</label>
                                <input
                                  type="date"
                                  name="date"
                                  value={formik.values.date}
                                  className= "form-input form-control input-error"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    setDefaultDate(e.target.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.date  && (
                                    <span className="form-error mt-1">
                                      {backendErrors.date}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                              
                          </div>


                          <div className="row">
                                <div className="col-md-6">
                                  <h4 className="card-title">
                                    <br />
                                    Items
                                  </h4>
                                </div>
                              </div>
                              <FieldArray
                                name="contents"
                                render={(arrayHelpers) => (
                                  <div>
                                    <button
                                      className="btn btn-primary mb-3"
                                      type="button"
                                      onClick={() => {
                                        let appendArr =arrayHelpers.form.values.contents[0];
                                        let initialArr ={
                                          operation: "",
                                          delivery_note_number: "",
                                          supplier:"",
                                          consomable: "",
                                          currency: "4",
                                          total_amount: "",
                                          quantity:"",
                                          unit_price:"",
                                          delivery_note:"",
                                          note:""
                                        }
                                        appendArr = (appendArr)?appendArr:initialArr;
                                        arrayHelpers.push(appendArr);
                                        setShowTableHeadings(true);
                                      
                                      }}
                                    >
                                      +
                                    </button>

                                  
                                      {showTableHeadings && (
                                        <div className="row">
                                        {/* //     <div className="col-md-1">Operation</div>
                                        //     <div className="col-md-1">Lot Number</div>
                                        //     <div className="col-md-2">Consumable</div>
                                        //     <div  className="col-md-1">Currency</div>
                                        //     <div  className="col-md-2">Amount</div>
                                        //     <div  className="col-md-1">Qty</div>
                                        //     <div  className="col-md-3">Delivery Note</div>
                                        //     <div  className="col-md-1"></div> */}
                                        </div>
                                      )}
                                        {formik.values.contents.map(
                                          (friend, index) => (
                                            <div  className="row" key={index}>
                                            
                                            <div  className="col-md-2">
                                                <div className="form-group status">
                                                <label> Operation</label><br/>
                                                
                                                  <Select
                                                    name={`contents[${index}].operation`}
                                                    options={operationArr}
                                                    value={operationArr.find(option => option.value == formik.values.contents[index].operation) || null} // Ensure correct format
                                                    onChange={(selectedOption) => {
                                                      formik.setFieldValue(`contents[${index}].operation`, selectedOption.value); // ✅ Store only value in Formik
                                                      customHandleInput({
                                                        target: {
                                                          name: `contents[${index}].operation`,
                                                          value: selectedOption.value, // ✅ Ensure only value is passed
                                                        },
                                                      });
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    placeholder="Select"
                                                    className="w-100"

                                                  />
                                                </div>
                                              </div>
                                              <div  className="col-md-2">
                                                <div className="form-group status">
                                                <label> Supplier</label><br/>
                                                
                                                  <Select
                                                    name={`contents[${index}].supplier`}
                                                    options={suppliers}
                                                    value={suppliers.find(option => option.value == formik.values.contents[index].supplier) || null} // Ensure correct format
                                                    onChange={(selectedOption) => {
                                                      formik.setFieldValue(`contents[${index}].supplier`, selectedOption.value); // ✅ Store only value in Formik
                                                      customHandleInput({
                                                        target: {
                                                          name: `contents[${index}].supplier`,
                                                          value: selectedOption.value, // ✅ Ensure only value is passed
                                                        },
                                                      });
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    placeholder="Select"
                                                    className="w-100"

                                                  />
                                                </div>
                                              </div>

                                              <div  className="col-md-4">
                                                <div className="form-group">
                                                <label>Delivery Note Number</label><br/>
                                                
                                                  <input
                                                  type="text"
                                                 
                                                    placeholder="Delivery note Number"
                                                    className="form-input form-control"
                                                    name={`contents[${index}].delivery_note_number`}
                                                    value={
                                                      formik.values.contents[index]
                                                        .delivery_note_number
                                                    }
                                                    onChange={formik.handleChange}
                                                  />
                                                </div>
                                              </div>
                                              <div  className="col-md-4">
                                                <div className="form-group status">
                                                <label> Consumable</label><br/>
                                                  <Select
                                                    name={`contents[${index}].consomable`}
                                                    options={statusOptions}
                                                    value={statusOptions.find(option => option.value == formik.values.contents[index].consomable) || null} // Ensure correct format
                                                    onChange={(selectedOption) => {
                                                      formik.setFieldValue(`contents[${index}].consomable`, selectedOption.value); // ✅ Store only value in Formik
                                                      customHandleInput({
                                                        target: {
                                                          name: `contents[${index}].consomable`,
                                                          value: selectedOption.value, // ✅ Ensure only value is passed
                                                        },
                                                      });
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    placeholder="Select"
                                                    className="w-100"

                                                    
                                                  />
                                                </div>
                                              </div>
                                              <div  className="col-md-2">
                                                <div className="form-group">
                                                <label>Quanity</label><br/>
                                                  <input
                                                    type="text"
                                                    onKeyPress={(event) => {
                                                      // Allow only numbers (0-9)
                                                      if (!/^[0-9.]$/.test(event.key)) {
                                                      event.preventDefault();
                                                      }
                                                    }}
                                                    placeholder="Enter Quantity"
                                                    className="form-input form-control"
                                                    name={`contents[${index}].quantity`}
                                                    value={
                                                      formik.values.contents[index]
                                                        .quantity
                                                    }
                                                    //onChange={formik.handleChange}
                                                    onChange={(e) => {
                                                      formik.handleChange(e);
                                                      const newQuantity = parseFloat(e.target.value) || 0;
                                                      const unitPrice = parseFloat(formik.values.contents[index].unit_price) || 0;
                                                      formik.setFieldValue(`contents[${index}].total_amount`, newQuantity * unitPrice);
                                                    }}
                                                  />
                                                </div>
                                              </div>
                                              <div  className="col-md-2">
                                                <div className="form-group status">
                                                <label>Curency</label><br/>
                                                  <Select
                                                    name={`contents[${index}].currency`}
                                                    options={primaryCurrency}
                                                    value={primaryCurrency.find(option => option.value == formik.values.contents[index].currency) || null} // Ensure correct format
                                                    onChange={(selectedOption) => {
                                                      formik.setFieldValue(`contents[${index}].currency`, selectedOption.value); // ✅ Store only value in Formik
                                                      customHandleInput({
                                                        target: {
                                                          name: `contents[${index}].currency`,
                                                          value: selectedOption.value, // ✅ Ensure only value is passed
                                                        },
                                                      });
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    placeholder="Select"
                                                    className="w-100"

                                                  />
                                                </div>
                                              </div>
                                            
                                              <div  className="col-md-2">
                                                <div className="form-group">
                                                <label>Unit Price</label><br/>
                                                  <input
                                                    type="text"
                                                    onKeyPress={(event) => {
                                                      // Allow only numbers (0-9)
                                                      if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                        event.preventDefault();
                                                      }
                                                    }}
                                                    placeholder="Enter Unit Price"
                                                    className="form-input form-control"
                                                    name={`contents[${index}].unit_price`}
                                                    value={
                                                      formik.values.contents[index]
                                                        .unit_price
                                                    }

                                                    //onChange={formik.handleChange}
                                                    onChange={(e) => {
                                                      formik.handleChange(e);
                                                      const newUnitPrice = parseFloat(e.target.value) || 0;
                                                      const quantity = parseFloat(formik.values.contents[index].quantity) || 0;
                                                      formik.setFieldValue(`contents[${index}].total_amount`, quantity * newUnitPrice);
                                                    }}
                                                  />
                                                </div>
                                              </div>
                                              
                                            
                                              <div  className="col-md-4">
                                                <div className="form-group">
                                                <label>Total Amount</label><br/>
                                                  <input
                                                  type="text"
                                                  onKeyPress={(event) => {
                                                    // Allow only numbers (0-9)
                                                    if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                                      event.preventDefault();
                                                    }
                                                  }}
                                                    placeholder="Total Amount"
                                                    className="form-input form-control"
                                                    name={`contents[${index}].total_amount`}
                                                    value={
                                                      formik.values.contents[index]
                                                        .total_amount
                                                    }
                                                    onChange={formik.handleChange}
                                                  />
                                                </div>
                                              </div>
                                              
                                              
                                              
                                              <div  className="col-md-5">
                                              <div className="form-group " >
                                                <label>Delivery Note</label><br/>
                                                <input
                                                className="form-group"
                                                type="file"
                                                name={`contents[${index}].delivery_note`}
                                                id={`fileupload-${index}`}

                                                onChange={(event) => {
                                                  //getFileData(event);

                                                  const file_link = event.target.files[0];
                                                  //console.log("file:", file_link);
                                                  //const fileName = file_link.name;
                                                  //0const fileName = file_link.name;
                                                  const reader = new FileReader();

                                                  reader.onloadend = () => {
                                                    formik.setFieldValue(
                                                      `contents[${index}].delivery_note`,
                                                      reader.result
                                                    );
                                                  };

                                                  if (file_link) {
                                                    reader.readAsDataURL(file_link);
                                                  }
                                                }}
                                              />
                                                </div>
                                              </div>
                                          
                                            
                                              <div  className="col-md-11">
                                                <div className="form-group">
                                                <label>Note</label><br/>
                                                  <input
                                                  type="text"
                                                  
                                                    placeholder="Note"
                                                    className="form-input form-control"
                                                    name={`contents[${index}].note`}
                                                    value={
                                                      formik.values.contents[index]
                                                        .note
                                                    }
                                                    onChange={formik.handleChange}
                                                  />
                                                </div>
                                              </div>
                                            
                                            
                                              <div  className="col-md-1">
                                                <div className="form-group">
                                                  <button
                                                    className="btn btn-danger"
                                                    style={{ marginTop: 30 }}
                                                    type="button"
                                                    onClick={() =>
                                                      arrayHelpers.remove(index)
                                                    }
                                                  >
                                                    -
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          )
                                        )}
                                    
                                  </div>
                                )}
                              />

                          <small>
                                  {backendErrors.status  && (
                                    <span className="form-error mt-1">
                                      {backendErrors.status}
                                    </span>
                                  )}
                                </small>
                               
                          <div className="text-end mt-4">
                            <button
                              type="submit" id="form-submit"
                              className="btn btn-primary"
                              disabled={formik.isSubmitting}
                            >
                              Add Stock Situation
                            </button>
                          </div>
                          </form>
                          </FormikProvider>
                 )}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default StockFollowUpAdd;
